import { Injectable } from '@angular/core';
import {
    HttpClient,
    HttpHeaders,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Injectable({ providedIn: 'root' })
export class CommonHttpModule {
    private baseUrl = environment.apiBaseDemUrl;

    constructor(private http: HttpClient) { }

    // commonHttp get method 
    get<T>(endpoint: string, params?: any, headers?: HttpHeaders): Observable<T> {
        const finalHeaders = headers ?? new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.get<T>(`${this.baseUrl}/${endpoint}`,
            {
                params,
                headers: finalHeaders,
                observe: 'response' as const
            }
        ).pipe(
            map((response) => response.body as T)
        );
    }


    // commonHttp post method 
post<T>(
    endpoint: string,
    body: any,
    headers?: HttpHeaders
): Observable<T> {

    let finalHeaders = headers;

    // Do not set Content-Type for FormData.
    // Browser will automatically set multipart/form-data
    // with the required boundary.
    if (!finalHeaders) {
        if (!(body instanceof FormData)) {
            finalHeaders = new HttpHeaders({
                'Content-Type': 'application/json'
            });
        }
    }

    return this.http.post<T>(
        `${this.baseUrl}/${endpoint}`,
        body,
        {
            headers: finalHeaders,
            observe: 'response' as const
        }
    ).pipe(
        map((response) => response.body as T)
    );
}

    postForReport<T>(endpoint: string, body: any, headers?: HttpHeaders,): Observable<T> {
        const finalHeaders = headers ?? new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.post(`${this.baseUrl}/${endpoint}`, body, {
            headers: finalHeaders,
            observe: 'response' as const,
            responseType: 'blob'
        }).pipe(
            map((response) =>
                response.body as T)
        );
    }


    // commonHttp put method 
    put<T>(endpoint: string, body: any, headers?: HttpHeaders): Observable<T> {
        const finalHeaders = headers ?? new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.http.put<T>(`${this.baseUrl}/${endpoint}`, body, {
            headers: finalHeaders,
            observe: 'response' as const
        }).pipe(
            map((response) => response.body as T)
        );
    }

    // commonHttp  method 
    delete<T>(endpoint: string, params: any, headers?: HttpHeaders): Observable<T> {
        const finalHeaders = headers ?? new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.http.delete<T>(`${this.baseUrl}/${endpoint}`, {
            params,
            headers: finalHeaders,
            observe: 'response' as const
        }).pipe(
            map((response) => response.body as T)
        );
    }

}